export default __webpack_public_path__ + "static/mockup-two-phone-db95da9131872ec7f945017805721b05.png";